// Ubicaciones2.js
import React, { useEffect, useState } from "react";
import {
    Grid,
    TextField,
    Autocomplete,
    Card,
    CardContent,
    Divider,
    Chip,
    Button,
    Collapse,
    useTheme,
    useMediaQuery,
} from "@mui/material";
import { GenericCard } from "src/general_components/GenericCard";
import SearchIcon from "@mui/icons-material/Search";
import RefreshIcon from "@mui/icons-material/Refresh";
import DoneIcon from "@mui/icons-material/Done";
import { ListTablePaginated } from "src/general_components/ListTablePaginated";
import { getUbicacionesFiltrado, getUbicacionesPaginated, getUbicacionesSummary } from "../helpers/UbicacionesData";
import esArray from "src/general_components/functionEsArray";
import { PageHeaderCard } from "src/general_components/PageHeaderCard";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { CajasProvider } from "src/context/CajasContext/CajasContext";
import { getDataSelect } from "src/hooks/structureTable";
import { getDepositos } from "../helpers/UbicacionesData";
import Swal from "sweetalert2";
import { postUbicaciones } from "../helpers/UbicacionesData";
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import { SnackbarMessenger } from "src/general_components/SnackbarMessenger";
import ExcelJS from "exceljs";
import { UbicacionesTotales } from "../components/UbicacionesTotales";

export const Ubicaciones = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [mostrarCantidad, setMostrarCantidad] = useState(false);
    const [bloquearInputs, setBloquearInputs] = useState(false);
    const [estados_ubicaciones, setEstadosUbicaciones] = useState([]);
    const [tiposEstantes, setTiposEstantes] = useState([]);
    const [tiposCajas, setTiposCajas] = useState([]);
    const [depositos, setDepositos] = useState([]);
    const [mostrarCardLimitesCantidad, setMostrarCardLimitesCantidad] = useState(false);
    const [summary, setSummary] = useState(null);
    const [summaryLoading, setSummaryLoading] = useState(false);
    const [responseService, setResponseService] = useState({
        loaded: false,
        data: [],
        total_records: 0,
    });

    const [message, setMessage] = useState("");
    const [severity, setSeverity] = useState("success");
    const [snackbarVisible, setSnackbarVisible] = useState(false);
    const [proceso_finalizado, setProcesoFinalizado] = useState(false);


    // Control de habilitación progresiva
    const [habilitados, setHabilitados] = useState({
        deposito: true,
        sector: false,
        modulo: false,
        estante: false,
        posicion: false,
        estibe: false,
        profundidad: false,
        tipoEstante: true,
        tipoCajas: true,
        estadoUbicacion: true,
    });



    // Estado para valores de coordenadas
    const [valoresCoordenadas, setValoresCoordenadas] = useState({
        deposito: null,
        sector: "",
        modulo: "",
        tipoEstante: null,
        estante: "",
        posicion: "",
        estibe: "",
        tipoCajas: [],
        profundidad: "",
        estadoUbicacion: []
    });

    // Estado para valores de cantidades
    const [valoresCantidades, setValoresCantidades] = useState({
        sector: "",
        modulo: "",
        tipoEstante: null,
        estante: "",
        posicion: "",
        estibe: "",
        tipoCajas: null,
        profundidad: "",
    });

    // Habilitación dinámica en cadena
    useEffect(() => {
        const { deposito, sector, modulo, estante, posicion, estibe } = valoresCoordenadas;

        setHabilitados({
            deposito: true,
            sector: !!deposito,                // se habilita al seleccionar depósito
            modulo: !!sector,                  // se habilita al ingresar sector
            estante: !!modulo,                 // se habilita al ingresar módulo
            posicion: !!estante,               // se habilita al ingresar estante
            estibe: !!posicion,                // se habilita al ingresar posición
            profundidad: !!estibe,             // se habilita al ingresar estibe

            // Campos no jerárquicos (siempre habilitados)
            tipoEstante: true,
            tipoCajas: true,
            estadoUbicacion: true,
        });
    }, [valoresCoordenadas]);

    useEffect(() => {
        const modelos = [
            { key: "owner_localizaciones", setter: setDepositos },
            { key: "estados_ubicaciones", setter: setEstadosUbicaciones },
            { key: "tipo_estante", setter: setTiposEstantes },
            { key: "tipo_cajas", setter: setTiposCajas },
        ];

        const cargarDatos = async () => {
            for (const { key, setter } of modelos) {
                // Leer del localStorage
                let data = esArray(
                    JSON.parse(localStorage.getItem(`siam-${key}`))?.[key]
                );

                // Si no hay datos en localStorage, los pedimos
                if (!data.length) {
                    data = await getDataSelect(key);
                }

                // Guardamos en estado
                setter(data);
            }
        };

        cargarDatos();
    }, []);

    // Listener para acciones de la IA
    useEffect(() => {
        const handler = (e) => {
            const { type, params } = e.detail || {};
            if (type !== "buscar_ubicaciones" || !params) return;

            // Resolver depósito y estado desde el estado del componente o localStorage
            const lsGet = (key) => {
                try { return esArray(JSON.parse(localStorage.getItem(`siam-${key}`))?.[key]); }
                catch { return []; }
            };
            const depositosData = depositos.length > 0 ? depositos : lsGet("owner_localizaciones");
            const estadosData   = estados_ubicaciones.length > 0 ? estados_ubicaciones : lsGet("estados_ubicaciones");

            const depositoObj = params.id_deposito
                ? depositosData.find((d) => String(d.id) === String(params.id_deposito)) || null
                : null;
            const estadoObj = params.id_estado
                ? estadosData.find((e) => String(e.id) === String(params.id_estado)) || null
                : null;

            // Actualizar UI con los valores recibidos
            setValoresCoordenadas({
                deposito: depositoObj,
                sector:      params.sector      || "",
                modulo:      params.modulo      || "",
                estante:     params.estante     || "",
                posicion:    params.posicion    || "",
                estibe:      params.estibe      || "",
                profundidad: params.profundidad || "",
                tipoEstante:     null,
                tipoCajas:       null,
                estadoUbicacion: estadoObj,
            });

            // Construir payload para la API directamente (sin pasar por validaciones de estado)
            const payload = {};
            if (params.id_deposito) payload.id_owner_localizaciones = params.id_deposito;
            if (params.sector)      payload.id_sector      = params.sector;
            if (params.modulo)      payload.id_modulo      = params.modulo;
            if (params.estante)     payload.id_estante     = params.estante;
            if (params.posicion)    payload.id_posicion    = params.posicion;
            if (params.estibe)      payload.id_estibe      = params.estibe;
            if (params.profundidad) payload.id_profundidad = params.profundidad;
            if (params.id_estado)   payload.id_estado_ubicaciones = params.id_estado;

            // Disparar búsqueda actualizando opciones del listado
            setOptions((prev) => ({
                ...prev,
                idElementData: payload,
                sinFilas: false,
                setResponseService: (res) => {
                    setResponseService({
                        loaded: true,
                        data: res?.data ?? [],
                        total_records: res?.total_records ?? 0,
                    });
                },
            }));
        };

        window.addEventListener("ai:action", handler);
        return () => window.removeEventListener("ai:action", handler);
    }, [depositos, estados_ubicaciones]); // se re-registra cuando cargan los datos

    // Handlers
    const limpiarFormulario = () => {
        setMostrarCantidad(false);
        setBloquearInputs(false);
        setSummary(null);
        setSummaryLoading(false);

        setResponseService({
            loaded: false,
            data: [],
            total_records: 0,
        });

        setValoresCoordenadas({
            deposito: null,
            sector: "",
            modulo: "",
            tipoEstante: null,
            estante: "",
            posicion: "",
            estibe: "",
            tipoCajas: [],
            profundidad: "",
            estadoUbicacion: [],
        });
    };
    const limpiarFormularioCantidades = () => {
        setValoresCantidades({
            ...valoresCantidades,
            sector: "",
            modulo: "",
            tipoEstante: null,
            estante: "",
            posicion: "",
            estibe: "",
            tipoCajas: null,
            profundidad: "",
        });
        setMostrarCardLimitesCantidad(false);
    };


    const limpiarFormularioCantidadesLimites = () => {
        setValoresCantidades({
            ...valoresCantidades,
            cant_posicion: "",
            cant_estibe: "",
            cant_profundidad: "",
        });

    };

    // Convierte los valores cargados en coordenadas o cantidades
    const asignarValores = (usarCantidades = false) => {
        const origen = usarCantidades ? valoresCantidades : valoresCoordenadas;

        const datos = {
            id_owner_localizaciones: origen.deposito?.id || "",
            id_sector: origen.sector || "",
            id_modulo: origen.modulo || "",
            id_estante: origen.estante || "",
            id_posicion: origen.posicion || "",
            id_estibe: origen.estibe || "",
            id_profundidad: origen.profundidad || "",

            id_tipo_estante: origen.tipoEstante?.id || "",
            id_estado_ubicaciones: Array.isArray(origen.estadoUbicacion)
                ? origen.estadoUbicacion.map((e) => e.id).join(",")
                : (origen.estadoUbicacion?.id || ""),
            id_tipo_cajas: Array.isArray(origen.tipoCajas)
                ? origen.tipoCajas.map((t) => t.id).join(",")
                : (origen.tipoCajas?.id || ""),
        };

        // limpio propiedades vacías o null/undefined
        const datosFiltrados = Object.fromEntries(
            Object.entries(datos).filter(([_, v]) => v !== "" && v !== null && v !== undefined)
        );

        // 👉 si estoy pasando coordenadas, inicializo valoresCantidades
        if (!usarCantidades) {
            setValoresCantidades((prev) => ({
                ...prev,
                ...datosFiltrados, // solo se cargan los que tengan valor
            }));
        }


        return datos;
    };

    // Validar que todos los campos numéricos sean enteros positivos
    const validarForm = (origen) => {
        const numeros = [
            origen.sector,
            origen.modulo,
            origen.estante,
            origen.posicion,
            origen.estibe,
            origen.profundidad,
        ];

        return numeros.every(v => {
            if (v === "" || v === null) return true; // permitir vacío
            const n = Number(v);
            return Number.isInteger(n) && n > 0;
        });
    };

    const validaciones = async (usarCantidades = false, nuevo_estante) => {
        let mensaje = false;
        const origen = usarCantidades ? valoresCantidades : valoresCoordenadas;
        // validar deposito
        if (origen.id_owner_localizaciones || origen.deposito?.id) {
            const depositoFiltrado = await getDepositos(origen.id_owner_localizaciones || origen.deposito?.id);
            if (depositoFiltrado.length === 0) {
                return "El valor de la coordenada depósito no existe en la base de datos";
            }
        } else {
            return "Se debe seleccionar un depósito";
        }

        // validar números
        if (!validarForm(origen)) {
            return "Los valores deben ser números enteros positivos";
        }

        // validar tipo de estante
        if (usarCantidades && !origen.tipoEstante && nuevo_estante === true) {
            return "Se debe seleccionar un tipo de estante";
        }

        // validar profundidad si existe
        if (origen.profundidad && !origen.profundidad > 0) {
            return "Se debe ingresar una cantidad válida en el campo Profundidad";
        }

        // validar que haya al menos 7 valores entre coordenadas y cantidades
        const llenos = [
            origen.deposito,
            origen.sector,
            origen.modulo,
            origen.estante,
            origen.posicion,
            origen.estibe,
            origen.profundidad,
            origen.id_owner_localizaciones,
            origen.id_sector,
            origen.id_modulo,
            origen.id_estante,
            origen.id_posicion,
            origen.id_estibe,
            origen.id_profundidad,
        ].filter(v => v !== "" && v !== null).length;

        if (usarCantidades && llenos < 7) {
            return "Se deben ingresar al menos 7 valores entre coordenadas y cantidades";
        }

        return mensaje;
    };

    const obtenerUbicaciones = async () => {
        const payload = asignarValores(false);
        const validacion = await validaciones(false);

        if (validacion) {
            return Swal.fire({
                icon: "warning",
                title: "¡Atención!",
                text: validacion,
            });
        } else {
            setSummary(null);
            setSummaryLoading(true);
            setOptions(prev => ({
                ...prev,
                idElementData: payload,
                sinFilas: false,
                setResponseService: (res) => {
                    setResponseService({
                        loaded: true,
                        data: res?.data ?? [],
                        total_records: res?.total_records ?? 0,
                    });
                },
            }));
            getUbicacionesSummary(payload)
                .then(setSummary)
                .finally(() => setSummaryLoading(false));
        }
    };

    useEffect(() => {
        if (!responseService.loaded) return;

        if (responseService.data.length > 0) {

            if (!proceso_finalizado) {
                setMostrarCantidad(true);
                setBloquearInputs(true);
            } else {
                setProcesoFinalizado(false);
                limpiarFormularioCantidadesLimites();
                limpiarFormularioCantidades();
                limpiarFormulario();

            }

            setSnackbarVisible(true);
            setSeverity("success");
            setMessage(
                `Búsqueda exitosa. Se encontraron ${responseService.total_records} ubicaciones.`
            );
        } else {
            setMostrarCantidad(false);
            setBloquearInputs(false);

            setSnackbarVisible(true);
            setSeverity("info");
            setMessage("No se encontraron ubicaciones con los filtros aplicados.");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [responseService]);

    const validarCamposObligatorios = (datos, camposRequeridos) => {

        for (const campo of camposRequeridos) {
            const valor = datos[campo];

            // Si el campo tiene una versión con id_* y esa tiene valor, se considera válido
            const campoId = `id_${campo}`;
            const valorId = datos[campoId];

            // Si el id existe y tiene valor, se omite la validación del campo base
            if (valorId !== undefined && valorId !== null && valorId !== "") {
                continue;
            }

            // Para selects (objetos con id)
            if (typeof valor === "object" && valor !== null) {
                if (!valor.id) {
                    return `El campo "${campo}" es obligatorio.`;
                }
                continue;
            }

            // Para strings o números
            if (
                valor === null ||
                valor === undefined ||
                valor === "" ||
                (typeof valor === "number" && isNaN(valor))
            ) {
                return `El campo "${campo}" es obligatorio.`;
            }
        }

        return false; // ✅ todo OK
    };



    const procesarDatos = async (nuevo_estante = false) => {

        // 🔹 Aseguramos que sea un array real (por el error anterior)
        let camposRequeridosCantidades = [
            "sector",
            "modulo",
            "estante",
            "posicion",
            "estibe",
            "tipoCajas",
            "profundidad",
        ];


        // 🔹 Si es un nuevo estante, agregamos los campos extra
        if (nuevo_estante === true) {
            camposRequeridosCantidades.push(
                "cant_posicion",
                "cant_estibe",
                "cant_profundidad",
                "tipoEstante",
            );
        }

        // 🔹 Validamos los campos obligatorios
        const validacion_obligatorios = validarCamposObligatorios(
            valoresCantidades,
            camposRequeridosCantidades
        );

        if (validacion_obligatorios) {
            setSnackbarVisible(true);
            setMessage(
                validacion_obligatorios +
                " Se deben completar todos los campos obligatorios para continuar."
            );
            setSeverity("warning");
            return; // Detiene la ejecución
        }
        const validacion = await validaciones(true, nuevo_estante);

        if (validacion) {
            return Swal.fire({
                icon: "warning",
                title: "¡Atención!",
                text: validacion,
            });
        }

        const payload = {};

        // Map de campos especiales que deben renombrarse
        const mapRenombres = {
            tipoEstante: "id_tipo_estante",
            tipoCajas: "id_tipo_cajas",
            estado_ubicacion: "id_estado_ubicaciones",
            deposito: "id_owner_localizaciones",
        };

        // Campos que pueden ser id_* o cant_*
        const camposCantId = ["sector", "modulo", "estante", "posicion", "profundidad", "estibe"];

        Object.entries(valoresCantidades).forEach(([key, value]) => {
            if (value === "" || value === null || value === undefined) return;

            if (mapRenombres[key]) {
                // Selectores → siempre id
                payload[mapRenombres[key]] = typeof value === "object" && value.id ? value.id : value;
            } else if (camposCantId.includes(key)) {
                // Si ya tengo un id_* cargado, usarlo
                const idKey = `id_${key}`;
                const cantKey = `cant_${key}`;

                if (valoresCantidades[idKey]) {
                    payload[idKey] = valoresCantidades[idKey];
                } else {
                    payload[cantKey] = value;
                }
            } else if (key.startsWith("id_")) {
                // Cualquier id_* ya listo se copia tal cual
                payload[key] = value;
            }
        });



        const response = await postUbicaciones(payload);

        if (response.status === "true") {
            setProcesoFinalizado(true);
            await obtenerUbicaciones(); // Refrescar la lista
        }
    };

    const continuar = () => {
        // 🔹 Aseguramos que sea un array real (por el error anterior)
        let camposRequeridosCantidades = [
            "sector",
            "modulo",
            "tipoEstante",
            "estante",
            "posicion",
            "estibe",
            "tipoCajas",
            "profundidad",
        ];
        const validacion_obligatorios = validarCamposObligatorios(valoresCantidades, camposRequeridosCantidades);

        if (validacion_obligatorios) {
            setSnackbarVisible(true);
            setMessage(validacion_obligatorios + " Se deben completar todos los campos obligatorios para continuar.");
            setSeverity("warning");
            return;
        };
        setMostrarCardLimitesCantidad(true);
    }

    // Render dinámico de inputs
    const renderCampo = (key, label, options, disabled = false, multiple = false, showId = false) => {
        if (options) {
            return (
                <Autocomplete
                    multiple={multiple}
                    options={options}
                    value={multiple ? (valoresCoordenadas[key] || []) : valoresCoordenadas[key]}
                    onChange={(_, newValue) =>
                        setValoresCoordenadas((prev) => ({ ...prev, [key]: newValue }))
                    }
                    getOptionLabel={(option) => showId
                        ? (option?.id + ' - ' + (option?.detalle || option?.nombre || ''))
                        : (option?.label || option?.detalle || option?.nombre || '')}
                    disabled={disabled || !habilitados[key] || false}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={label}
                            variant="outlined"
                            fullWidth
                            disabled={disabled || !habilitados[key] || false}
                        />
                    )}
                />
            );
        }
        return (
            <TextField
                label={label}
                type="number"
                variant="outlined"
                fullWidth
                disabled={disabled || !habilitados[key]}
                value={valoresCoordenadas[key]}
                onChange={(e) =>
                    setValoresCoordenadas((prev) => ({
                        ...prev,
                        [key]: e.target.value,
                    }))
                }
            />
        );
    };

    // Render dinámico de inputs
    const renderCampoCantidad = (key, label, options, disabled = false, showId = false) => {
        if (options) {
            return (
                <Autocomplete
                    options={options}
                    value={valoresCantidades[key]}
                    onChange={(_, newValue) =>
                        setValoresCantidades((prev) => ({ ...prev, [key]: newValue }))
                    }
                    getOptionLabel={(option) => showId
                        ? (option?.id + ' - ' + (option?.detalle || option?.nombre || ''))
                        : (option?.label || option?.detalle || option?.nombre || '')}
                    disabled={disabled}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={label}
                            variant="outlined"
                            fullWidth
                            disabled={disabled}
                        />
                    )}
                />
            );
        }
        return (
            <TextField
                label={label}
                type="number"
                variant="outlined"
                fullWidth
                disabled={disabled}
                value={valoresCantidades[key]}
                onChange={(e) =>
                    setValoresCantidades((prev) => ({
                        ...prev,
                        [key]: e.target.value,
                    }))
                }
            />
        );
    };

    // Candidatos para Cantidad
    const candidatosCantidad = [
        { key: "sector", label: "Sector" },
        { key: "modulo", label: "Módulo" },
        { key: "estante", label: "Estante" },
        { key: "tipoEstante", label: "Tipo de Estante", options: tiposEstantes, showId: true },
        { key: "posicion", label: "Posición" },
        { key: "estibe", label: "Estibe" },
        { key: "profundidad", label: "Profundidad", always: true },
        { key: "tipoCajas", label: "Tipo de Cajas", options: tiposCajas, always: true, showId: true },
    ];

    // Filtrar dinámicamente → mostrar solo vacíos
    const camposCantidad = candidatosCantidad.filter((campo) => {
        if (campo.key === "tipoEstante") {
            // Mostrar tipoEstante SOLO si estante no está cargado
            return !valoresCoordenadas.estante;
        }
        return (
            campo.always ||
            !valoresCoordenadas[campo.key] ||
            valoresCoordenadas[campo.key] === ""
        );
    });

    // Agregar botones
    camposCantidad.push(
        {
            label: "Limpiar",
            isButton: true,
            component: (
                <Button
                    onClick={limpiarFormularioCantidades}
                    variant="contained"
                    endIcon={<RefreshIcon sx={{ ml: { xs: 1, sm: 5 } }} />}
                    color="secondary"
                    fullWidth
                >
                    Limpiar
                </Button>
            ),
        },
        {
            label: "Procesar",
            isButton: true,
            component: (
                <Button
                    onClick={valoresCantidades.id_estante ? procesarDatos : continuar}
                    variant="contained"
                    endIcon={valoresCantidades.id_estante ? <DoneIcon sx={{ ml: { xs: 1, sm: 10 } }} /> : <ArrowForwardRoundedIcon sx={{ ml: { xs: 1, sm: 5 } }} />}
                    color={valoresCantidades.id_estante ? "success" : "primary"}
                    fullWidth
                // disabled={disabledSubmitCamposCantidad}
                >
                    {valoresCantidades.id_estante ? "Procesar" : "Continuar"}
                </Button>
            ),
        }
    );

    // Distribución de filas
    const mitad = Math.ceil(camposCantidad.length / 2);
    const fila1 = camposCantidad.length <= 5 ? camposCantidad : camposCantidad.slice(0, mitad);
    const fila2 = camposCantidad.length <= 5 ? [] : camposCantidad.slice(mitad);

    const columns = [
        { field: "id", headerName: "ID", flex: 0.3 },
        { field: "id_owner_localizaciones", headerName: "Dep", flex: 0.3 },
        { field: "sector", headerName: "Sector", flex: 0.3 },
        { field: "modulo", headerName: "Módulo", align: "center", flex: 0.3 },
        { field: "estante", headerName: "Estante", align: "center", flex: 0.3 },
        { field: "posicion", headerName: "Posición", align: "center", flex: 0.3 },
        { field: "profundidad", headerName: "Profundidad", align: "center", flex: 0.3 },
        { field: "estibe", headerName: "Estibe", align: "center", flex: 0.3 },
        {
            field: "estado",
            headerName: "Estado",
            align: "center",
            flex: 0.5,
            renderCell: (params) => {
                const estado = params.value; // viene como número o string
                let color = "default";
                let label = "";

                switch (String(estado)) {
                    case "Disponible":
                        color = "success"; // verde
                        label = "Disponible";
                        break;
                    case "Reservada":
                        color = "warning"; // amarillo/naranja
                        label = "Reservada";
                        break;
                    case "En Espera":
                        color = "info"; // celeste
                        label = "En Espera";
                        break;
                    case "Ocupada":
                        color = "error"; // rojo
                        label = "Ocupada";
                        break;
                    case "Baja":
                        color = "default"; // gris
                        label = "Baja";
                        break;
                    default:
                        color = "default";
                        label = estado || "Desconocido";
                }
                return (
                    <Chip
                        label={label}
                        color={color}
                        size="small"
                        variant={color === "default" ? "outlined" : "filled"}
                        sx={{ m: 1 }}
                    />
                );
            },
        },
    ];

    const generateExcel = async ({ totalPages, limit, idElementData }) => {
        try {

            const workbook = new ExcelJS.Workbook();
            const sheet = workbook.addWorksheet("Ubicaciones");

            const idElementDataConIdCajas = { ...idElementData, incluir_id_cajas: true };

            // ==============================
            // ENCABEZADOS CON COLOR
            // ==============================
            sheet.columns = [
                { header: "ID", key: "id", width: 20 },
                { header: "Sector", key: "sector", width: 20 },
                { header: "Módulo", key: "modulo", width: 20 },
                { header: "Estante", key: "estante", width: 20 },
                { header: "Posición", key: "posicion", width: 20 },
                { header: "Profundidad", key: "profundidad", width: 20 },
                { header: "Estibe", key: "estibe", width: 20 },
                { header: "Estado", key: "estado", width: 20 },
                { header: "Tipo Estante", key: "tipo_estante", width: 20 },
                { header: "ID Caja", key: "id_cajas", width: 20 },
            ];

            // Aplicar estilo a encabezados
            sheet.getRow(1).eachCell((cell) => {
                cell.fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: "FF1E90FF" }, // Azul fuerte
                };
                cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
                cell.alignment = { horizontal: "center", vertical: "middle" };
            });

            // ==============================
            // ACUMULADOR
            // ==============================
            let allItems = [];

            // ==============================
            // LOOP DE PAGINAS
            // ==============================
            for (let page = 1; page <= totalPages; page++) {
                const offset = (page - 1) * limit;

                const res = await getUbicacionesPaginated(limit, offset, idElementDataConIdCajas);

                if (res?.data) {
                    allItems.push(...res.data);
                } else {
                    console.warn(`Página ${page} sin resultados`);
                }
            }


            // ==============================
            // MAPA DE COLORES POR ESTADO
            // ==============================
            const estadoColors = {
                "Ocupada": "FFFFCCCC",
                "Disponible": "FFCCFFCC",
                "Reservada": "FFFFFFB3",
                "Baja": "FFD9D9D9",
                "default": "FFDCE6F1",
            };

            // ==============================
            // CARGAR EN EXCEL
            // ==============================
            allItems.forEach((u) => {

                const estadoTexto = u.relations?.estados_ubicaciones?.detalle ?? u.estado ?? "";
                const idCaja = u.id_caja ?? "-";

                const row = sheet.addRow({
                    id: u.id,
                    sector: u.sector ?? u.relations?.estantes?.sector ?? "",
                    modulo: u.modulo ?? u.relations?.estantes?.modulo ?? "",
                    estante: u.estante ?? u.relations?.estantes?.estante ?? "",
                    posicion: u.posicion,
                    profundidad: u.profundidad,
                    estibe: u.estibe,
                    estado: estadoTexto,
                    tipo_estante: u.relations?.tipo_estante?.nombre ?? "",
                    id_cajas: idCaja,
                });

                // ==============================
                // APLICAR COLOR POR ESTADO
                // ==============================
                const fillColor = estadoColors[estadoTexto] || estadoColors.default;

                row.getCell("estado").fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: fillColor },
                };

                // Centrado de las celdas
                row.eachCell((cell) => {
                    cell.alignment = { horizontal: "center", vertical: "middle" };
                });
            });

            // ==============================
            // DESCARGAR ARCHIVO
            // ==============================
            const buffer = await workbook.xlsx.writeBuffer();

            const blob = new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = "ubicaciones.xlsx";
            link.click();

            console.log("✔ Excel generado correctamente");

        } catch (error) {
            console.error("❌ Error generando Excel:", error);
        }
    };

    const mobileComponent = ({ row }) => (
        <GenericCard
            row={row}
            columns={columns}
        />
    );

    const [options, setOptions] = useState({
        cols: columns,
        get: getUbicacionesFiltrado,
        getPaginated: getUbicacionesPaginated,
        idElementData: valoresCoordenadas,
        pageSize: [5, 10, 25],
        edit: false,
        limit: 50,
        sinFilas: true,
        filter: true,
        exportData: true,
        server: true,
        exportarExcel: true,
        handleExportarExcel: generateExcel,
        mobileComponent: mobileComponent,
    });






    return (
        <>
            <Grid style={{ marginBottom: "50px", paddingTop: 10 }}>

                <PageHeaderCard title="Consulta y Alta de Ubicaciones" icon={<LocationOnIcon />} />

                <CajasProvider>
                    {/* Primera Card: Coordenadas */}
                    <Card elevation={3}>
                        <CardContent>
                            <Divider sx={{ mb: 3, position: "relative" }}>
                                <Chip
                                    label="Coordenadas"
                                    color="secondary"
                                    variant="outlined"
                                    sx={{ fontWeight: "bold", position: "absolute", left: 16, background: "#fff" }}
                                />
                                <Chip
                                    label="Filtros para busqueda de ubicaciones"
                                    color="error"
                                    variant="outlined"
                                    sx={{ fontWeight: "bold" }}
                                />

                            </Divider>

                            {/* Fila 1 */}
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs={12} sm sx={{ flexBasis: { xs: "100%", sm: "20%" } }}>
                                    {renderCampo("deposito", "Depósito", depositos, bloquearInputs)}
                                </Grid>
                                <Grid item xs={12} sm sx={{ flexBasis: { xs: "100%", sm: "20%" } }}>
                                    {renderCampo("sector", "Sector", null, bloquearInputs)}
                                </Grid>
                                <Grid item xs={12} sm sx={{ flexBasis: { xs: "100%", sm: "20%" } }}>
                                    {renderCampo("modulo", "Módulo", null, bloquearInputs)}
                                </Grid>
                                <Grid item xs={12} sm sx={{ flexBasis: { xs: "100%", sm: "20%" } }}>
                                    {renderCampo("estante", "Estante", null, bloquearInputs)}
                                </Grid>
                                <Grid item xs={12} sm sx={{ flexBasis: { xs: "100%", sm: "20%" } }}>
                                    {renderCampo("tipoEstante", "Tipo de Estante", tiposEstantes, bloquearInputs, false, true)}
                                </Grid>
                            </Grid>

                            {/* Fila 2 */}
                            <Grid container spacing={2} alignItems="center" sx={{ mt: 1 }}>

                                <Grid item xs={12} sm sx={{ flexBasis: { xs: "100%", sm: "20%" } }}>
                                    {renderCampo("posicion", "Posición", null, bloquearInputs)}
                                </Grid>
                                <Grid item xs={12} sm sx={{ flexBasis: { xs: "100%", sm: "20%" } }}>
                                    {renderCampo("profundidad", "Profundidad", null, bloquearInputs)}
                                </Grid>
                                <Grid item xs={12} sm sx={{ flexBasis: { xs: "100%", sm: "20%" } }}>
                                    {renderCampo("estibe", "Estibe", null, bloquearInputs)}
                                </Grid>
                                <Grid item xs={12} sm sx={{ flexBasis: { xs: "100%", sm: "20%" } }}>
                                    {renderCampo("tipoCajas", "Tipo de Cajas", tiposCajas, bloquearInputs, true, true)}
                                </Grid>
                                <Grid item xs={12} sm sx={{ flexBasis: { xs: "100%", sm: "20%" } }}>
                                    {renderCampo("estadoUbicacion", "Estado de Ubicaciones", estados_ubicaciones, bloquearInputs, true)}
                                </Grid>

                                {/* Ambos botones Limpiar y Recupera juntos. En PC ocupan el final derecho de la fila (10 a 20%). En Móvil dividen el ancho 50% y 50% */}
                                <Grid item xs={6} sm="auto" sx={{ ml: { sm: "auto" }, flexBasis: { xs: "50%", sm: "15%" } }}>
                                    <Button
                                        onClick={limpiarFormulario}
                                        variant="contained"
                                        endIcon={<RefreshIcon sx={{ ml: { xs: 1, sm: 2 } }} />}
                                        color="secondary"
                                        fullWidth
                                    >
                                        Limpiar
                                    </Button>
                                </Grid>
                                <Grid item xs={6} sm="auto" sx={{ flexBasis: { xs: "50%", sm: "15%" } }}>
                                    <Button
                                        onClick={obtenerUbicaciones}
                                        endIcon={<SearchIcon sx={{ ml: { xs: 1, sm: 5 } }} />}
                                        variant="contained"
                                        fullWidth
                                    >
                                        Recupera
                                    </Button>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>

                    {/* Segunda Card: Cantidad */}
                    <Collapse in={mostrarCantidad} timeout={500}>
                        <Card elevation={3} sx={{ mt: 2 }}>
                            <CardContent>
                                <Divider sx={{ mb: 3, position: "relative" }}>
                                    <Chip
                                        label="Cantidades"
                                        color="secondary"
                                        variant="outlined"
                                        sx={{ fontWeight: "bold", position: "absolute", left: 16, background: "#fff" }}
                                    />
                                    <Chip
                                        label="Carga de nuevas ubicaciones"
                                        color="success"
                                        variant="outlined"
                                        sx={{ fontWeight: "bold" }}
                                    />

                                </Divider>

                                {/* Fila 1 */}
                                <Grid container spacing={2} alignItems="center">
                                    {fila1.map((campo, idx) => (
                                        <Grid key={idx} item xs={campo.isButton ? 6 : 12} sm sx={{ flexBasis: { xs: campo.isButton ? "50%" : "100%", sm: `${100 / fila1.length}%` } }}>
                                            {campo.component || renderCampoCantidad(campo.key, campo.label, campo.options, false, campo.showId)}
                                        </Grid>
                                    ))}
                                </Grid>

                                {/* Fila 2 */}
                                {fila2.length > 0 && (
                                    <Grid container spacing={2} alignItems="center" sx={{ mt: 1 }}>
                                        {fila2.map((campo, idx) => (
                                            <Grid key={idx} item xs={campo.isButton ? 6 : 12} sm sx={{ flexBasis: { xs: campo.isButton ? "50%" : "100%", sm: `${100 / fila2.length}%` } }}>
                                                {campo.component || renderCampoCantidad(campo.key, campo.label, campo.options, false, campo.showId)}
                                            </Grid>
                                        ))}
                                    </Grid>
                                )}
                            </CardContent>
                        </Card>
                    </Collapse>
                    {/* Tercera Card: Cantidad por estante*/}
                    <Collapse in={mostrarCardLimitesCantidad} timeout={500}>
                        <Card elevation={3} sx={{ mt: 2 }}>
                            <CardContent>
                                <Divider sx={{ mb: 3, position: "relative" }}>
                                    <Chip
                                        label="Cantidades limites por estante"
                                        color="secondary"
                                        variant="outlined"
                                        sx={{ fontWeight: "bold", position: "absolute", left: 16, background: "#fff" }}
                                    />
                                    <Chip
                                        label="Carga de cantidades limites"
                                        color="warning"
                                        variant="outlined"
                                        sx={{ fontWeight: "bold" }}
                                    />

                                </Divider>

                                {/* Fila 1 */}
                                <Grid container spacing={2} alignItems="center">
                                    <Grid key={"cant_posicion"} item xs={12} sm sx={{ flexBasis: { xs: "100%", sm: `${100 / 5}%` } }}>
                                        <TextField
                                            label={"Cantidad Maxima de Posiciones"}
                                            type="number"
                                            variant="outlined"
                                            fullWidth
                                            // disabled={disabled}
                                            value={valoresCantidades["cant_posicion"] || ""}
                                            onChange={(e) =>
                                                setValoresCantidades((prev) => ({
                                                    ...prev,
                                                    "cant_posicion": e.target.value,
                                                }))
                                            }
                                        />
                                    </Grid>
                                    <Grid key={"cant_estibe"} item xs={12} sm sx={{ flexBasis: { xs: "100%", sm: `${100 / 5}%` } }}>
                                        <TextField
                                            label={"Cantidad Maxima de Estibes"}
                                            type="number"
                                            variant="outlined"
                                            fullWidth
                                            // disabled={disabled}
                                            value={valoresCantidades["cant_estibe"] || ""}
                                            onChange={(e) =>
                                                setValoresCantidades((prev) => ({
                                                    ...prev,
                                                    "cant_estibe": e.target.value,
                                                }))
                                            }
                                        />
                                    </Grid>
                                    <Grid key={"cant_profundidad"} item xs={12} sm sx={{ flexBasis: { xs: "100%", sm: `${100 / 5}%` } }}>
                                        <TextField
                                            label={"Cantidad Maxima de Profundidades"}
                                            type="number"
                                            variant="outlined"
                                            fullWidth
                                            // disabled={disabled}
                                            value={valoresCantidades["cant_profundidad"] || ""}
                                            onChange={(e) =>
                                                setValoresCantidades((prev) => ({
                                                    ...prev,
                                                    "cant_profundidad": e.target.value,
                                                }))
                                            }
                                        />
                                    </Grid>
                                    <Grid key={"cant_limpiar"} item xs={6} sm sx={{ flexBasis: { xs: "50%", sm: `${100 / 5}%` } }}>
                                        <Button
                                            onClick={limpiarFormularioCantidadesLimites}
                                            variant="contained"
                                            endIcon={<RefreshIcon sx={{ ml: { xs: 1, sm: 5 } }} />}
                                            color="secondary"
                                            fullWidth
                                        >
                                            Limpiar
                                        </Button>
                                    </Grid>
                                    <Grid key={"cant_procesar"} item xs={6} sm sx={{ flexBasis: { xs: "50%", sm: `${100 / 5}%` } }}>
                                        <Button
                                            onClick={() => procesarDatos(true)}
                                            variant="contained"
                                            endIcon={<DoneIcon sx={{ ml: { xs: 1, sm: 5 } }} />}
                                            color="success"
                                            fullWidth
                                        >
                                            Procesar
                                        </Button>
                                    </Grid>
                                </Grid>


                            </CardContent>
                        </Card>
                    </Collapse>
                    <UbicacionesTotales
                        summary={summary}
                        tiposCajas={tiposCajas}
                        loading={summaryLoading}
                    />
                    <Grid sx={{ mt: 2 }}>
                        <ListTablePaginated options={options} />
                    </Grid>
                </CajasProvider>
                <SnackbarMessenger
                    open={snackbarVisible}
                    message={message}
                    severity={severity}
                    close={() => {
                        setSnackbarVisible(false);
                    }}
                />
            </Grid>
        </>
    );
};
